import $ from 'jquery';

let accordionBlock = $('.js-accordion');
let accordionHiddenElement = $('.js-accordion > .js-accordion-hidden');
let accordionShownElement = $('.js-accordion > .js-accordion-shown');
const getScreenCenter = () => {
  const sectionAccordion = document.querySelector('.section-accordion');
  const line = document.getElementById('line');
  const sectionTop = sectionAccordion.getBoundingClientRect().top + window.scrollY;
  const windowHeight = window.innerHeight;
  const sectionHeight = sectionAccordion.offsetHeight;

  const midWindow = windowHeight / 2;

  if (sectionTop + sectionHeight > window.scrollY + midWindow && sectionTop < window.scrollY + midWindow) {
    const scrollDistance = window.scrollY + midWindow - sectionTop;
    line.style.height = `${scrollDistance}px`;
  }  else if (sectionTop > window.scrollY + midWindow) {
    line.style.height = '0';
  }  else if (sectionTop + sectionHeight < window.scrollY + midWindow) {
    line.style.height = '100%';
  }
};

accordionShownElement.click(function () {
  let hiddenElement = $(this).next('.js-accordion-hidden');
  if ($(this).parent().hasClass('accordion-item_open')) {
    accordionHiddenElement.slideUp(300);
    accordionBlock.removeClass('accordion-item_open');
    console.log($(this).attr);
    $(this).attr('aria-expanded', 'false');
    hiddenElement.attr('aria-hidden', 'true');
    return false;
  } else {
    accordionHiddenElement.slideUp(300);
    $(this).parent().siblings().removeClass('accordion-item_open');
    $(this).attr('aria-expanded', 'true');
    hiddenElement.attr('aria-hidden', 'false');
    $(this).next().slideDown(300);
    $(this).parent().addClass('accordion-item_open');
  }
});

accordionShownElement.keydown(function (event) {
  if (event.key === 'Enter') {
    $(this).click();
  }
});


document.addEventListener('DOMContentLoaded', function() {
  window.addEventListener('scroll', function() {
    getScreenCenter();
  });
  window.addEventListener('resize', function() {
    getScreenCenter();
  });
});


